import axios, { AxiosResponse } from 'axios';
import { http } from "@/plugins/axios";

const endPoint = '/Polls';

// Типы данных для состояния
export interface IPoll {
  Id: number;
  Title: string;
  IsReaded: boolean;
  // Добавь остальные поля из API при необходимости
}

export interface IPollResult {
  QuestionId: number;
  Answer: string;
  // Добавь остальные поля при необходимости
}

export interface IPollState {
  poll: IPoll | null;
  pollResults: IPollResult[] | null;
}

/**
 * Сохранение результата опроса
 *
 * @param   {Object}  PollingResult
 * @param   {string}  PollingResult.ID       Код доступа
 * @param   {string}  PollingResult.ExtraInfo  Дополнительная информация
 * @param   {Array}  PollingResult.Answers     Ответы на вопросы
 *
 * @return  {Object}                           Статус сохранения результата опроса
 */
const saveResult = (payload: object): Promise<AxiosResponse<IPoll>> => {
  return http.post(`${endPoint}/SaveResult`, payload);
}

/**
 * Обновление информации о прочтении
 *
 * @param   {string}  ID  Код доступа
 *
 * @return  {Object}        Статус обновления информации о прочтении
 */
const setReadedFlag = (ID: string): Promise<AxiosResponse<IPoll>> => {
  return http.post(`${endPoint}/SetReadedFlag`, { ID });
}

/**
 * Получение результата опроса
 *
 * @param   {string}  ID  Код доступа
 *
 * @return  {Object}        Результата опроса
 */
const results = (ID: string): Promise<AxiosResponse<IPollResult[]>> => {
  return http.post(`${endPoint}/Results`, { ID });
}

export default {
  saveResult,
  setReadedFlag,
  results
}